export default "__VITE_ASSET__Baayv84x__"